import { fetchData } from "../services/fetch-data";
import { AtomParserService } from "../services/atom-parser";
import { reactive, toRefs } from "vue";
const initialState = {
    entries: [],
    loading: false
};
export function useEntries() {
    const state = reactive(initialState);
    async function fetchEntries(url) {
        if (!url)
            throw new Error("Fetch data url cannot be null or undefined");
        state.loading = true;
        const response = await fetchData(url);
        const parserService = new AtomParserService();
        if (response) {
            state.entries = parserService.parse(response);
        }
        state.loading = false;
    }
    return {
        ...toRefs(state),
        fetchEntries
    };
}
